var U = 100;
function X(D) {
  var n = D.fontFamily, c = D.fontSize, W = !!(n || c);
  n === void 0 && (n = "Calibri"), c === void 0 && (c = 12);
  var u = [], j = {}, h = [], q = {}, l = [], y = {}, e = [], S = {}, i = [], p = {};
  l.push({
    size: c,
    family: n,
    custom: W
  }), y["-:-"] = 0, e.push({}), S["-"] = 0, i.push({
    left: {},
    right: {},
    top: {},
    bottom: {}
  }), p["-:-/-:-/-:-/-:-"] = 0, e.push({
    gray125: !0
  });
  function E(o, P) {
    var G = o.align, H = o.alignVertical, J = o.textRotation, K = o.indent, L = o.wrap, v = o.fontFamily, m = o.fontSize, b = o.fontWeight, B = o.fontStyle, C = o.color, I = o.backgroundColor, t = o.borderColor, r = o.borderStyle, R = o.leftBorderColor, z = o.leftBorderStyle, F = o.rightBorderColor, w = o.rightBorderStyle, x = o.topBorderColor, T = o.topBorderStyle, A = o.bottomBorderColor, M = o.bottomBorderStyle, a = P.format, V = "".concat(v || "-", ":").concat(m || "-", ":").concat(b || "-", ":").concat(B || "-", ":").concat(C || "-"), _ = I || "-", k = "".concat(x || t || "-", ":").concat(T || r || "-") + "/" + "".concat(F || t || "-", ":").concat(w || r || "-") + "/" + "".concat(A || t || "-", ":").concat(M || r || "-") + "/" + "".concat(R || t || "-", ":").concat(z || r || "-"), N = "".concat(G || "-", "/").concat(H || "-", "/").concat(J || "-", "/").concat(K || "-", "/").concat(L || "-", "/").concat(a || "-", "/").concat(V, "/").concat(_, "/").concat(k), O = q[N];
    if (O !== void 0)
      return O;
    var d;
    a && (d = j[a], d === void 0 && (d = j[a] = String(U + u.length), u.push(a)));
    var s = W ? 0 : void 0;
    (v || m || b || B || C) && (s = y[V], s === void 0 && (s = y[V] = String(l.length), l.push({
      custom: !0,
      size: m || c,
      family: v || n,
      weight: b,
      style: B,
      color: C
    })));
    var f;
    I && (f = S[_], f === void 0 && (f = S[_] = String(e.length), e.push({
      color: I
    })));
    var g;
    return (t || r || R || z || F || w || x || T || A || M) && (g = p[k], g === void 0 && (g = p[k] = String(i.length), i.push({
      left: {
        style: z || r,
        color: R || t
      },
      right: {
        style: w || r,
        color: F || t
      },
      top: {
        style: T || r,
        color: x || t
      },
      bottom: {
        style: M || r,
        color: A || t
      }
    }))), h.push({
      fontId: s,
      fillId: f,
      borderId: g,
      align: G,
      alignVertical: H,
      textRotation: J,
      indent: K,
      wrap: L,
      formatId: d
    }), q[N] = String(h.length - 1);
  }
  return E({}, {}), {
    getStyles: function() {
      return {
        formats: u,
        styles: h,
        fonts: l,
        fills: e,
        borders: i
      };
    },
    getStyle: E
  };
}
export {
  U as FORMAT_ID_STARTS_FROM,
  X as default
};
//# sourceMappingURL=index.es475.js.map
